import { render, staticRenderFns } from "./UserDetailsProfessionalInfo.vue?vue&type=template&id=34224dd8&"
import script from "./UserDetailsProfessionalInfo.vue?vue&type=script&lang=js&"
export * from "./UserDetailsProfessionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports